import NotesHeader from './components/NotesHeader/NotesHeader';
import NotesContent from './components/NotesContent/NotesContent';
import { Stack, useTheme, useMediaQuery } from '@mui/material';
import { useBannerStore } from '@/stores/bannerStore';

const MyNotes = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 900px and below
  const { headerHeight } = useBannerStore();
  return (
    <Stack
      alignItems="center"
      pt={4}
      pb={0}
      px={isMobile ? 2 : 4}
      height={`calc(100vh - ${headerHeight}px)`}
      minWidth={0}
      overflow="hidden"
    >
      <NotesHeader />
      <NotesContent />
    </Stack>
  );
};

export default MyNotes;
